import { QueryClient, QueryClientProvider as TanStackQueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { PropsWithChildren } from 'react';

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: true,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: Infinity,
      throwOnError: true,
    },
  },
});

const disableTanstackDevtools = import.meta.env.VITE_DISABLE_TANSTACK_DEVTOOLS === 'true';

function isPlaywrightControlledBrowser() {
  return typeof navigator !== 'undefined' && navigator.webdriver;
}

export function QueryClientProvider({ children }: PropsWithChildren) {
  const shouldShowTanstackDevtools = !disableTanstackDevtools && !isPlaywrightControlledBrowser();

  return (
    <TanStackQueryClientProvider client={client}>
      {children}
      {shouldShowTanstackDevtools && <ReactQueryDevtools initialIsOpen={false} />}
    </TanStackQueryClientProvider>
  );
}
